import { Component, Input, Output, EventEmitter, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Agent} from '../../../_models/agent';
import { UserGroup} from '../../../_models/user_group';

import { DbTransform } from '../../../_helpers/db.transform';
import { AuxFunction } from '../../../_helpers/aux.function';

import * as fromSortableColumn from '../../../sortableColumn/sortableColumn.function';


@Component({
  selector: 'app-agent',
  templateUrl: './agent-list.component.html'
})
export class AgentListComponent implements OnInit {

  dbt: DbTransform;
  auxFunction: AuxFunction;

  setTimeout_aux: number;

  title: string;
  subtitle: string;

  current_company: string;

  deleteModal: boolean;

  searchAgentForm: FormGroup;

  @ViewChild('searchButton',  {static: true}) searchButton: ElementRef;

  @Input() agents: Agent[];
  @Input() currentAgent: Agent;
  @Input() filterFields: any;
  @Input() userGroupList: UserGroup[];
  @Output() searchAgents = new EventEmitter<any>();
  @Output() setCurrentAgent = new EventEmitter<Agent>();
  @Output() deleteAgent = new EventEmitter<Agent>();

  constructor(
    public router: Router,
    private formBuilder: FormBuilder
  ) {}

  // convenience getter for easy access to form fields
  get f() { return this.searchAgentForm.controls; }

  ngOnInit() {

    this.dbt = new DbTransform(localStorage.getItem('enviroment')); //this.globals.currentUserEnviroment);
    this.auxFunction = new AuxFunction();

    this.setTimeout_aux = 1000;

    this.title = 'Módulo de Agentes';
    this.subtitle = 'Listado de Agentes';

    this.current_company = localStorage.getItem('company');
    console.log('---> Campañía del usuario logueado: ' + this.current_company);

    this.deleteModal = false;

    // Colocamos inicialmente el foco en el botón de búsqueda.
    this.searchButton.nativeElement.focus();

    this.searchAgentForm = this.formBuilder.group({
      f_name: this.filterFields['f_name'],
      f_email: this.filterFields['f_email'],
      f_group: this.filterFields['f_group'],
      f_permissions: this.filterFields['f_permissions'],
      // NOTA: forzamos de momento que sólo se muestren agentes del entorno 'dialum' (hasta que esté preparada su BD).
      // f_enviroment: 'dialum', // localStorage.getItem('enviroment'),
      // IMPORTANTE: forzamos de momento que sólo se muestren agentes de la empresa 'Dialum'.
      f_company: 'Dialum'
    });

    console.log(' Listado de grupos = ');
    console.log(this.userGroupList);

    // Preparamos el listado de grupos para poder luego obtener sus nombres rápidamente.
    this.auxFunction.setHashList(this.userGroupList, this.dbt.t('id'), this.dbt.t('name'));

  } // End function ngOnInit

  // Función usada como parámetro para aplicar a cada elemento como filto de un Pipe propio.

  // En este caso se asegura de que sólo se muestren los usuarios cuya empresa es 'Dilaum'.
  filterCompany(element: any): boolean {
    // console.log('filterCompany Item: ');
    // console.log(element);

    // if (element['company'] === this.current_company) {
      if (element['company'] === 'Dialum') {
      return true;
    }
    return false;
  } // End function filterCompany

  // NOTA: función que coge los parámetros del formulario y los "emite" fuera.
  buttonGetAgentList(): void {
    console.log('-->--> Pulsado botón Buscar Agentes.');

    // Preparamos el listado de grupos para poder luego obtener sus nombres rápidamente.
    // NOTA: hay que hacerlo aquí también porque en la función ngOnInit el listado de
    // grupos no le da tiempo a cargarse y aparece vacío.
    this.auxFunction.setHashList(this.userGroupList, this.dbt.t('id'), this.dbt.t('name'));

    console.log('** -> auxFunction hashList:');
    console.log(this.auxFunction.hashList);

    this.searchAgents.emit(this.searchAgentForm.value);
  }

  buttonCreateAgent() {
    console.log('-->--> Pulsado botón Crear Nuevo Agente.');

    this.setCurrentAgent.emit(null);

    this.router.navigate(['/agent-edit']);
  } // End function buttonCreateAgent

  buttonSetCurrentAgent(agent: Agent | null) {
    console.log('-> -> Seleccionado Agente:');
    console.log(agent);

    this.setCurrentAgent.emit(agent);

    this.router.navigate(['/agent-edit']);

    // setTimeout(() => {this.router.navigate(['/agent-edit'])}, this.setTimeout_aux);

  } // End function buttonSetCurrentAgent

  buttonDeleteAgent(agent: Agent) {
    console.log('-> -> Borrar Agente:');
    console.log(agent);

    this.setCurrentAgent.emit(agent);

    this.showDeleteModal(true);

  } // End function buttonDeleteAgent

  showDeleteModal(value: boolean) {
    this.deleteModal = value;

  } // End function showDeleteModal

  confirmDeleteAgent() {
    this.deleteAgent.emit(this.currentAgent);
    this.showDeleteModal(false);
  }

  // --------- Detectar tecla presionada
  onKeydown(event: any) {
    console.log('Presionada tecla...');
    console.log(event);
    if (event.key === 'Enter') {
      console.log('--> Tecla ENTER.');

      this.buttonGetAgentList();
    }
  } // End function onKeydown

  // IMPORTANTE: Cuando el array que alimenta la tabla html se le incluye un "filtro/pipe" entonces no ordena, no funciona.
  // En este caso no funcionará la ordenación porque estamos usando el filtro "| filterFunction: filterCompany"
  // a la hora de listar los agentes.
  // Función que ordena el listado de elementos.
  onSorted(event: any) {
    console.log('--> onSorted Tabla directiva lanzada:');
    console.log(event);

    // console.log(' -> Columna a ordenar: ' + event.sortColumn);
    // console.log(' -> Dirección orden: ' + event.sortDirection);
    // console.log(' -> Es número: ' + event.isNumeric);

    // Si hubiese que realizar alguna acción específica para la columna seleccionada.
    // switch (event.sortColumn) {
    //   case 'mat_desc':
    //     break;

    //   case 'lagm_platz':
    //     break;
    // }

    // Se lanza la función de ordenación del array de inventario.
    // Modifica directamente el array pasado como primer parámetro.
    // NOTA: el nombre de la columna, al ser para ORACLE, tendrá que estar en mayúsculas.
    this.agents = fromSortableColumn.sortByColumn(
      this.agents, event.sortColumn, event.sortDirection, event.isNumeric);

    console.log('--> Array agents de la ordenación:');
    console.log(this.agents);

  } // End function onSorted

} // End class AgentListComponent
